// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsPage_container__31Czp"};